// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_loader__tBTIj {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

@keyframes Loader_rotation__tNTO- {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.Loader_spinner__eRb2E {
  display: flex;
  width: 48px;
  height: 48px;
  border: 5px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: Loader_rotation__tNTO- 1s linear infinite;
}

.Loader_animatePulse__1zmEA {
  animation: Loader_pulse__cf\\+Zn 1.5s infinite ease-in-out;
}

@keyframes Loader_pulse__cf\\+Zn {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Loader/Loader.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AACD;;AAEA;EACC;IACC,uBAAA;EACA;EAED;IACC,yBAAA;EAAA;AACF;AAGA;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oDAAA;AADD;;AAIA;EACC,yDAAA;AADD;;AAIA;EACC;IACA,YAAA;EADC;EAGD;IACA,UAAA;EADC;EAGD;IACA,YAAA;EADC;AACF","sourcesContent":[".loader {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n}\n\n@keyframes rotation {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.spinner {\n\tdisplay: flex;\n\twidth: 48px;\n\theight: 48px;\n\tborder: 5px solid black;\n\tborder-bottom-color: transparent;\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tbox-sizing: border-box;\n\tanimation: rotation 1s linear infinite;\n}\n\n.animatePulse {\n\tanimation: pulse 1.5s infinite ease-in-out;\n}\n\n@keyframes pulse {\n\t0% {\n\topacity: 0.6;\n\t}\n\t50% {\n\topacity: 1;\n\t}\n\t100% {\n\topacity: 0.6;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Loader_loader__tBTIj`,
	"spinner": `Loader_spinner__eRb2E`,
	"rotation": `Loader_rotation__tNTO-`,
	"animatePulse": `Loader_animatePulse__1zmEA`,
	"pulse": `Loader_pulse__cf+Zn`
};
export default ___CSS_LOADER_EXPORT___;
